import classNames from 'classnames';
import { forwardRef } from 'react';
import styles from './styles.module.scss';

export interface ISettingOptionProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  rightIcon?: React.ReactNode;
  active?: boolean;
}

const SettingOption = forwardRef<HTMLButtonElement, ISettingOptionProps>(
  ({ rightIcon, children, className, active, ...props }: ISettingOptionProps, ref) => {
    return (
      <button
        role='menuitem'
        ref={ref}
        className={classNames(styles.container, className, { [styles.active]: active })}
        {...props}
      >
        {children}
        {rightIcon}
      </button>
    );
  },
);

SettingOption.displayName = 'SettingOption';
export default SettingOption;
